import React from "react";
import { Reveal, MaskLines } from "@/components/Motion";
import { aboutBugg as a, images } from "@/config/site";

export default function AboutBugg() {
  return (
    <>
      <section data-testid="about-bugg-hero" className="pt-36 pb-16 sm:pt-48 sm:pb-20 bg-dh-bg">
        <div className="mx-auto max-w-[1200px] px-5 sm:px-8">
          <div className="grid items-end gap-12 md:grid-cols-12 md:gap-16">
            <Reveal className="md:col-span-5">
              <div className="relative">
                <div className="absolute -inset-3 -z-10 border border-dh-gold/25" />
                <img
                  src={images.buggPortrait}
                  alt="Portrait of Bugg, author and founder of Dhamma Publishing House"
                  className="w-full object-cover"
                />
              </div>
            </Reveal>
            <div className="md:col-span-7">
              <Reveal>
                <p className="font-body text-[11px] uppercase tracking-ultra text-dh-gold">Author • Storyteller • Founder</p>
              </Reveal>
              <h1 className="mt-4 font-display text-6xl text-dh-cream sm:text-8xl lg:text-9xl">
                <MaskLines lines={[a.name]} />
              </h1>
              <Reveal delay={0.15}>
                <p className="mt-4 font-serif-soft text-xl italic text-dh-cream/70">{a.subheading}</p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <section data-testid="about-bugg-body" className="bg-dh-bg pb-24 sm:pb-28">
        <div className="mx-auto max-w-[680px] px-5 sm:px-8">
          {a.sections.map((s, i) => (
            <Reveal key={i} delay={0.05}>
              {s.pullQuote ? (
                <figure data-testid="about-bugg-pull-quote" className="relative left-1/2 w-[min(94vw,880px)] -translate-x-1/2 py-10 text-center sm:py-12">
                  <div className="gold-rule mx-auto mb-8 w-16 opacity-70" />
                  <blockquote className="mx-auto font-serif-soft text-lg italic leading-snug text-dh-gold sm:whitespace-nowrap sm:text-[clamp(1.15rem,1.9vw,1.5rem)]">
                    {s.pullQuote}
                  </blockquote>
                  <div className="gold-rule mx-auto mt-8 w-16 opacity-70" />
                </figure>
              ) : (
                <div className={i > 0 ? "mt-12 sm:mt-14" : ""}>
                  <p data-testid={`about-bugg-label-${i}`} className="font-body text-[11px] uppercase tracking-ultra text-dh-gold">{s.label}</p>
                  <div className="gold-rule mt-4 w-10 opacity-60" />
                  <div className="mt-7 space-y-6">
                    {s.paragraphs.map((p, j) => (
                      <p key={j} className="font-body text-base leading-relaxed text-dh-cream/80 sm:text-lg">{p}</p>
                    ))}
                  </div>
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </section>

      <section data-testid="about-bugg-closing" className="bg-dh-bg pb-28 sm:pb-36">
        <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8">
          <Reveal>
            <div className="gold-rule mx-auto mb-10 w-24" />
            <p className="mx-auto max-w-xl font-display text-2xl italic leading-snug text-dh-cream sm:text-3xl">
              {a.closing}
            </p>
            <p data-testid="about-bugg-closing-support" className="mt-6 font-body text-base leading-relaxed text-dh-cream/65 sm:text-lg">
              {a.closingSupport}
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
